export const fmt = (n: number, d = 2) =>
  isNaN(n) || !isFinite(n) ? "—" : n.toFixed(d).replace(/\.?0+$/, "") || "0";

export const STANDARD_ROUND = [4,5,6,7,8,9,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48];

export const nearestRound = (diam: number) => {
  let best = STANDARD_ROUND[0];
  for (const s of STANDARD_ROUND) {
    if (s >= diam) { best = s; break; }
    best = s;
  }
  return best >= diam ? best : STANDARD_ROUND[STANDARD_ROUND.length - 1];
};
